import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { actions } from '@/redux/accommodation/hotel/reducer';
import { HotelIcon } from '@/assets/images/icons/screens';

const EmptyRoomList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const goToCreateRoom = useCallback(() => {
        dispatch(actions.goToCreateRoom());
    }, [dispatch]);

    return (
        <div className="empty-room-list">
            <div>
                <HotelIcon />
            </div>
            <div>
                <span>
                    {t("Oops! Looks you haven't created yet any Room")}
                </span>
            </div>
            <div>
                <Button
                    className="create-button-filled"
                    onClick={() => goToCreateRoom()}
                >
                    {t('Add new room').toUpperCase()}
                </Button>
            </div>
        </div>
    );
};

export default EmptyRoomList;
